<template>
  <div>
    <div v-show="OpState==='TicketList'">
      <populate-form
        formTitle="邀約劃位(先搜尋票券)"
        fkey="oi01"
        ref="filterForm"
        populateOptionVar="filterOptions"
        formDataObjVar="filterData"
        @customValueChanged="filterChanged"
      ></populate-form>
      <b-table
        stacked="sm"
        :items="Tickets"
        :fields="fields"
      >
        <template v-slot:cell(print_time)="row">
          {{getPartFromDatetimeStr(row.item.print_time,'date')}}
        </template>
        <template v-slot:cell(confirm_use_status)="row">
          {{row.item.confirm_use_status==='running'?'可使用':(row.item.confirm_use_status==='confirmed'?'已使用':(row.item.confirm_use_status==='partialUsed'?'已鎖定使用':(row.item.confirm_use_status==='cancelled'?'已退票':(row.item.confirm_use_status==='dispatching'?'分票待領取':'未定義'))))}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button v-if="!row.item.used&&!row.item.is_in_negotiate&&!row.item.is_reserved_now" @click="OfferInviteThisTicket(row.item)">邀約</b-button>
        </template>
      </b-table>
    </div>
    <div v-show="OpState==='TicketInvite'">
      <populate-form
        formTitle="邀約劃位(挑選邀約日期時間)"
        fkey="oi02"
        ref="inviteForm"
        populateOptionVar="inviteOptions"
        formDataObjVar="inviteData"
        @customValueChanged="inviteChanged"
      ></populate-form>
    </div>
  </div>
</template>

<script>


export default {
  name: 'StoreOfferNegotiate',
  components:{
    
  },
  props: {
    'doneCB':Function,
    'lockedInviteDate':String
  },
  data: function () {
    return {
      isLoaading:false,
      OpState:'TicketList',
      service_minute_unit:30,
      dayPlots:[],
      inviteData:{},
      inviteOptions:[
        {
          componentType:'b-button',
          col:2,
          placeholder:'回列表',
          execCallback:()=>{this.OpState='TicketList'}
        },
        {
          componentType:'span',
          akey:'inviteInfo',
          col:10,
          placeholder:''
        },
        {
          componentType:'b-form-select',
          akey:'selectedServiceItem',
          col:12,
          dataOptions:[{text:'無資料',value:0}]
        },
        {
          componentType:'date-picker',
          col:4,
          akey:'invite_date',
          placeholder:"選取邀約日期"
        },
        /*{
          componentType:'vue-timepicker',
          col:4,
          akey:'invite_time',
          disabled:true,
          placeholder:"請先挑選日期",
          title:'挑選日期後方可點擊'
        },*/
        {
          componentType:'b-form-select',
          akey:'invite_time',
          col:4,
          //dataOptions:[{text:'請先選擇日期',value:''}],
          optionVar:'dayPlots',
          optionLabel:'time_str',
          defaultValue:null,
          placeholder:'請先選日期後再選可用時段'
        },
        {
          col:4
        },
        {
          componentType:'b-form-textarea',
          akey:'remark',
          col:12,
          rows:3,
          defaultValue:"親愛的顧客請確認此劃位時間您是OK的唷!",
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:1
            },
            {
              col:3,
              placeholder:'取消',
              execCallback:()=>{this.OpState = 'TicketList'}
            },
            {
              col:2
            },
            {
              col:3,
              placeholder:'確認邀約',
              execCallback:this.sendInvite
            },
            {
              col:1
            }
          ]
        }
      ],
      Tickets:[],
      fields:[
        {
          key:'user_name',
          label:'票券使用人'
        },
        {
          key:'ticket_project_name',
          label:'課程名稱'
        },
        {
          key:'ticket_project_name',
          label:'課程名稱'
        },
        {
          key:'ticket_no',
          label:'票號'
        },
        {
          key:'print_time',
          label:'購票日期'
        },
        {
          key:'confirm_use_status',
          label:'狀態'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      Services:[],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-form-select',
          optionVar:'Services',
          defaultValue:null,
          akey:'selectedServiceItem',
          optionLabel:'service_name',
          col:12,
          placeholder:"全部課程"
        },
        {
          componentType:"text",
          akey:'keyword',
          defaultValue:'',
          col:6,
          placeholder:'以客戶姓名篩選',
          execCallback:this.searchTickets,
        },
        {
          componentType:"text",
          akey:'ticket_no',
          defaultValue:'',
          col:6,
          placeholder:'以完整AA票號查詢',
          execCallback:this.searchTickets,
          title:'知道票號可在會員主動聯繫前找到此票券'
        },
        {
          componentType:'b-form-checkbox',
          akey:'exclude_in_negotiate',
          defaultValue:true,
          col:3,
          placeholder:'未邀約'
        },
        {
          componentType:'b-form-checkbox',
          akey:'exclude_reserved',
          defaultValue:true,
          col:3,
          placeholder:'未劃位'
        },
        {
          componentType:'b-form-checkbox',
          akey:'exclude_used',
          defaultValue:true,
          col:3,
          placeholder:'未使用'
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:"查詢",
          execCallback:this.searchTickets
        },
      ],
    }
  },
  methods: {
    sendInvite() {
      if (!this.inviteData.invite_time || !this.inviteData.invite_time.id) {
        this.$refs.inviteForm.triggerAlert("請先選擇好邀請時間再送出")
        return
      }
      let Param = {
        module:'store',
        method:'offerReservationDealByStore',
        start_plot_time_id:this.inviteData.invite_time.id,
        ticket_item_id:this.inviteData.ticket_item_id,
        remark:this.inviteData.remark,
        from_reservation_id:0,
        merchant_service_id:this.inviteData.selectedServiceItem,
        expire_minutes:30
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok == 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        //邀約成功回列表,重抓列表
        vm.$bus.fnShowInfo("邀約已成功送出")
        //整個要自爆回主介面,需要parant的method
        vm.doneCB()
      }, this)

    },
    OfferInviteThisTicket(item) {
      this.$refs.inviteForm.initDefault()
      this.inviteData.inviteInfo = '邀約對象:'+item.user_name+'('+item.ticket_no+')'
      let dataOptions = []
      for (let i=0;i<item.ticket_services.length;i++) {
        dataOptions.push({text:item.ticket_services[i].service_name,value:item.ticket_services[i].merchant_service_id})
      }
      this.inviteOptions[2].dataOptions = dataOptions
      //this.inviteOptions[2].defaultValue = this.inviteOptions[2].dataOptions[0]
      this.inviteData.ticket_item_id = item.ticket_item_id
      this.inviteData.ticket_project_id = item.ticket_project_id
      this.inviteData.selectedServiceItem = this.inviteOptions[2].dataOptions[0].value
      // inviteOptions的順序改變時要記得改這裡,可選日期透過設定動態抓取
      this.inviteOptions[3].datePickerConfig = {
        format:'YYYY-MM-DD',
        useCurrent:false,
        minDate:this.getDateByStr('',0,'-'),
        maxDate:this.getDateByStr('',this.$bus.session.store_service_rule.max_open_reserve_days,'-'),
        disabledDates:this.$bus.session.store_service_rule.active_rest_days
      }
      if (this.lockedInviteDate) {
        this.inviteData.invite_date = this.lockedInviteDate
        this.inviteOptions[3].datePickerConfig.maxDate = this.lockedInviteDate
        this.inviteOptions[3].datePickerConfig.minDate = this.lockedInviteDate
      }
      this.$refs.inviteForm.refreshModelVar('invite_date')
      // 這個inviteInfo不拿出來settimeout會顯示不出來哩
      setTimeout(() => {
        this.$refs.inviteForm.refreshModelVar('inviteInfo')
        this.inviteData.invite_date = this.lockedInviteDate
        this.OpState = 'TicketInvite'
      }, 400);
    },
    inviteChanged(upd) {
      // 根據選擇的日期而要重撈時間的選項
      // 若日期無效則警告,時間不給選,邀請送出不給按
      if (upd.key === 'invite_date') {
        if (upd.val) {
          const dt = new Date(upd.val)
          const wd = dt.getDay()
          this.inviteOptions[4].disabled = false
          this.inviteOptions[4].minuteInterval = parseInt(this.$bus.session.store_service_rule.service_minute_unit)
          this.inviteOptions[4].minHour = parseInt(this.$bus.session.store_service_rule['starttime_day'+wd].substr(0,2))
          this.inviteOptions[4].maxHour = parseInt(this.$bus.session.store_service_rule['endtime_day'+wd].substr(0,2))
          // 改呼叫api重綁選項
          let Param = {
            module:'store',
            method:'getStorePlotByDate',
            date:upd.val,
            ticket_project_id:this.filterData.selectedServiceItem?this.filterData.selectedServiceItem.ticket_project_id:0,
            merchant_service_id:0//this.inviteData.selectedServiceItem
          }
          this.$bus.apiCall(Param, function (data, vm) {
            if (data.ok === 0) {
              vm.dayPlots = []
              vm.$refs.inviteForm.triggerAlert("取得選取日期可劃位開始時段失敗："+data.msg)
              return
            }
            vm.dayPlots = data.data
            setTimeout(() => {
              vm.$refs.inviteForm.refreshModelVar('invite_time')
            }, 50);
          }, this)
        }
        else {
          this.dayPlots = []
          this.inviteData.invite_time = null
          this.inviteOptions[4].disabled = true
          this.$refs.inviteForm.refreshModelVar('invite_time')
        }
      }
    },
    filterChanged(upd) {
      if (upd.key === 'selectedServiceItem' && !this.isLoaading) {
        this.searchTickets()
      }
    },
    searchTickets() {
      let Param = {
        module:'store',
        method:'getTicketsByStore',
        store_id: this.$bus.session.merchant_store_id,
        ticket_no:this.filterData.ticket_no,
        ticket_project_id:this.filterData.selectedServiceItem?this.filterData.selectedServiceItem.ticket_project_id:0,
        keyword:this.filterData.keyword,
        exclude_in_negotiate:this.filterData.exclude_in_negotiate?1:0,
        exclude_reserved:this.filterData.exclude_reserved?1:0,
        exclude_used:this.filterData.exclude_used?1:0
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
        }
        vm.Tickets = data.data
      }, this)
    },
    removeRestTimeRule(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store',
          'method':'removeStoreRestTimeRule',
          'store_id': this.$bus.session.merchant_store_id,
          'rule_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchRestRules()
        }, this)
      })
    },
    searchRestRules() {
      if (this.isLoaading) {
        return
      }
      let Param = {
        'module':'store',
        'method':'getStoreRestTimeRules',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.isLoaading = true
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.restTimeRules =data.data
        vm.isLoaading = false
      }, this)
    },
    confirmAdd() {
      if (!this.addData.no_service_start || !this.addData.no_service_end) {
        this.$refs.addForm2.triggerAlert('規則的休息起訖時間未選擇完成')
        return
      }
      if (this.addData.no_service_start > this.addData.no_service_end) {
        this.$refs.addForm2.triggerAlert('休息時間起訖錯誤')
        return
      }
      let Param = {
        'module':'store',
        'method':'addStoreRestTimeRule',
        'store_id': this.$bus.session.merchant_store_id,
        'nth_weekday':this.addData.nth_weekday,
        'week_day':this.addData.week_day,
        'no_service_start':this.addData.no_service_start,
        'no_service_end':this.addData.no_service_end,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchRestRules()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("添加設定成功")
        vm.modalShowAdd = false
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    if (this.$bus.session && this.$bus.session != 'undefined' && (this.$bus.getRole() === 'merchant' || this.$bus.getRole() === 'spalogin') ) {
      let service_items = []
      for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
        service_items.push({
          'merchant_service_id': this.$bus.session.ticket_projects[i].service_items[0].merchant_service_id,
          'service_name':this.$bus.session.ticket_projects[i].service_items[0].service_name,
          'ticket_project_id':this.$bus.session.ticket_projects[i].ticket_project_id,
        })
      }
      this.Services = service_items
    }
    this.isLoaading = true
    this.$refs.filterForm.initDefault()
    this.filterData.selectedServiceItem = null
    this.$refs.filterForm.refreshModelVar()
    this.isLoaading = false
    //this.$bus.session.max_open_reserve_days
    //this.$refs.inviteForm.setEnabledDates('invite_date',['2019-07-24','2019-07-26','2019-07-27','2019-07-29'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
